<script setup>
import configurationProvider from "@/Core/configurationProvider";

var notFoundRedirect = configurationProvider.getString("NOT_FOUND_REDIRECT_URL");

if (notFoundRedirect) {
  window.location.href = notFoundRedirect;
}
</script>
<template>
  <div class="not-found" v-if="!notFoundRedirect">
    <div class="not-found-card">
      <svg class="not-found-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <h2>{{ $t('pageNotFound') }}</h2>
      <p>{{ $t('pageNotFoundMessage') }}</p>
    </div>
  </div>
</template>

<style scoped>
.not-found {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.not-found-card {
  text-align: center;
  padding: 48px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  max-width: 400px;
}

.not-found-icon {
  width: 56px;
  height: 56px;
  color: #999;
  margin-bottom: 16px;
}

.not-found-card h2 {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.not-found-card p {
  margin: 0;
  font-size: 14px;
  color: #888;
}
</style>
